import React, { useState } from "react";
import "./NewTicket.css";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import HamburgerMenu from "../../../Components/HamburgerMenu/HamburgerMenu";
import BottomBar from "../../../Components/BottomBar/BottomBar";
import Alert from "../../../Components/Alert/Alert";
import { useAuth } from "../../../AuthContext";
import Axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useBaseUrl } from "../../../ApiContext";

export default function NewTicket() {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl()
  const navigate = useNavigate();
  const location = useLocation();
  const { from } = location.state || {};
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [newTicketTitle, setNewTicketTitle] = useState("");
  const [newTicketDescription, setNewTicketDescription] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const newTicketTitleHandler = (e) => {
    setNewTicketTitle(e.target.value);
  };

  const newTicketDescriptionHandler = (e) => {
    setNewTicketDescription(e.target.value);
  };

  const submitNewTicketHandler = async () => {
    if (!newTicketTitle || !newTicketDescription) {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    }

    if (!newTicketTitle) {
      setAlertText("عنوان نباید خالی باشد");
    } else if (!newTicketDescription) {
      setAlertText("توضیحات نباید خالی باشد");
    }

    if (newTicketTitle && newTicketDescription) {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
      setAlertText("در حال ثبت تیکت...");
      try {
        const response = await Axios.post(
          `${baseUrl}/create_ticket`,
          { title: newTicketTitle, text: newTicketDescription },
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        console.log(response.data);
        setNewTicketTitle("");
        setNewTicketDescription("");
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
          navigate("/tickets");
        }, 2000);
        setAlertText("تیکت شما ثبت شد");
      } catch (error) {
        console.log("Error during sending new ticket", error);
      }
    }
  };

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          <img
            src="/images/ic_menu.svg"
            alt="menu"
            className="menuIcon"
            onClick={hamburgerMenuHandler}
          />
          </div>
          <div className="pageTitle horizontalBorder">ثبت تیکت جدید</div>
          <div className="newTicketTitle responsiveWidth">
            <input
              type="text"
              placeholder="عنوان"
              vlaue={newTicketTitle}
              onChange={newTicketTitleHandler}
            />
          </div>
          <div className="newTicketDescription responsiveWidth">
            <textarea
              placeholder="توضیحات"
              vlaue={newTicketDescription}
              onChange={newTicketDescriptionHandler}
            ></textarea>
          </div>
          <button
            className="mainBtn submitNewTicketBtn"
            onClick={submitNewTicketHandler}
          >
            ثبت تیکت جدید
          </button>
          <Alert alertText={alertText} showAlert={showAlert} bottom="6rem" />
        </div>
      </div>
      <BottomBar prevPath={from} />
    </div>
  );
}
